import { Link } from "react-router-dom";
import MarketingLayout from "@/components/MarketingLayout";
import SEO from "@/components/SEO";

const SECTIONS = [
  ["What we collect", "Account info (email, name), the items and locations you create, photos you upload, and basic analytics about how the app is used (page views, error logs). Nothing more than is needed to run Nestled."],
  ["What we don't do", "We do not sell your data. We do not share your inventory with advertisers. We do not train machine-learning models on your content."],
  ["How we use it", "To deliver the product: store your items, render your photos, send you reset emails and family invites you've asked for. That's the whole list."],
  ["Where it lives", "MongoDB Atlas (database) and managed object storage (photos). All transit is encrypted via TLS. Photos use owner-only signed access — a stranger with a file URL still can't see it."],
  ["Third-party services we rely on", "Stripe for payments. Resend for emails. OpenAI Whisper for voice-to-text. These vendors only see what's necessary (e.g., your email for sending a reset link). Their own privacy policies govern that processing."],
  ["Your rights", "Export, correct, or delete your data any time. Email contact@nestledapp.io and we'll respond within 30 days. You can also delete items, locations, photos, and your account directly in the app."],
  ["Cookies", "We use a single httpOnly authentication cookie. No advertising cookies, no third-party tracking pixels."],
  ["Changes", "If we make material changes to this policy, we'll email registered users and post a notice in-app."],
];

export default function Privacy() {
  return (
    <MarketingLayout>
      <SEO
        title="Privacy"
        description="Nestled's privacy policy in plain English. What we collect, what we don't do, how we store and protect your data."
        path="/privacy"
      />
      <section className="max-w-3xl mx-auto px-6 md:px-10 pt-16 md:pt-20 pb-16">
        <span className="text-xs font-bold uppercase tracking-[0.18em] text-terracotta-600">Last updated: Feb 2026</span>
        <h1 className="mt-3 font-heading text-4xl sm:text-5xl text-stoneink-900 font-semibold tracking-tight">Privacy</h1>
        <p className="mt-5 text-stoneink-700 leading-relaxed">
          We made this as short as we honestly could. If anything below is unclear, write to <a href="mailto:contact@nestledapp.io" className="text-terracotta-600 hover:text-terracotta-700">contact@nestledapp.io</a> and we&apos;ll explain like humans.
        </p>

        <div className="mt-12 space-y-10">
          {SECTIONS.map(([h, body]) => (
            <div key={h}>
              <h2 className="font-heading text-2xl text-stoneink-900 font-medium tracking-tight">{h}</h2>
              <p className="mt-3 text-stoneink-700 leading-relaxed">{body}</p>
            </div>
          ))}
        </div>

        <p className="mt-12 text-stoneink-500 text-sm">
          See also our <Link to="/terms" className="text-terracotta-600 hover:text-terracotta-700">terms of service</Link>.
        </p>
      </section>
    </MarketingLayout>
  );
}
